import template from './container.dot';
const containerTemplate = template.default ? template.default : template;
export { containerTemplate };
